<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->

<div mat-dialog-content>
	<p>
		{{ appStrings.IMPORT_TICKET_INSERTION_POINT_STEP_TEXT }}
	</p>
</div>

<mat-divider class="padded-divider"></mat-divider>

<!-- Footer -->
<button-footer
	mat-dialog-actions
	(buttonSaveOrClose)="onNext()"
	[saveOrCloseButtonText]="appStrings.UICONTROL_TEXT_NEXT | uppercase"
>
	<!-- BEGIN PLACEHOLDER REPLACE AS PART OF TP-5850 -->
	<!-- <button type="button" middleButton mat-stroked-button color="primary" (click)="onBack()">
		{{ appStrings.UICONTROL_TEXT_BACK }}
	</button> -->
	<!-- END PLACEHOLDER REPLACE AS PART OF TP-5850 -->
	<button leftButton type="button" mat-button mat-dialog-close color="primary" automationId="cancel">
		{{ appStrings.UICONTROL_TEXT_CANCEL.toUpperCase() }}
	</button>
</button-footer>
